import React from 'react';
import { Body } from '~/components/atom/Typography';
import Link from '~/components/molecule/Link';
import JustificationContainer from '../JustificationContainer';
import QRCode from 'react-qr-code';
import styled, { css } from 'styled-components';
import Div from '../Div';
import Divider from '../Divider';

const text = {
  step1: '1. Scan deze QR-code met een authenticator-app zoals',
  microsoftAuthenticatorLink: 'Microsoft Authenticator',
  step2: '2. Voer een eenmalige code in van je authenticator-app.',
};

const MICROSOFT_AUTHENTICATOR_URL =
  'https://www.microsoft.com/nl-nl/security/mobile-authenticator-app';

type Props = {
  qrCode: string;
  onAuthPage?: boolean;
};

const TOTPSetupInstructions: React.FC<Props> = ({
  qrCode,
  onAuthPage = false,
}) => {
  const fontColor = onAuthPage ? { group: 'white' as const } : undefined;
  return (
    <>
      <Body size="base" margin={[null]} color={fontColor}>
        {text.step1}&nbsp;
        <Link to={MICROSOFT_AUTHENTICATOR_URL} openInNewTab>
          {text.microsoftAuthenticatorLink}
        </Link>
        .
      </Body>
      <JustificationContainer justification="center" width="100%">
        <QRCodeContainer
          backgroundColor={{ group: 'white' }}
          padding={['base']}
          border={{ radius: 'm' }}
          dataTestId="mfa-setup-qr-code-container"
        >
          <QRCode value={qrCode} size={200} level="H" />
        </QRCodeContainer>
      </JustificationContainer>

      {!onAuthPage && <Divider margin={[null, null, 'xs']} />}

      <Body size="base" color={fontColor}>
        {text.step2}
      </Body>
    </>
  );
};

const QRCodeContainer = styled(Div)(
  () => css`
    display: block;
    width: fit-content;
    margin: 0 auto;
  `,
);

export default TOTPSetupInstructions;
